module.exports = __webpack_public_path__ + "static/img/logo1.6e5ec2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo1.png
// module id = 204
// module chunks = 49